import classes from './Button.module.scss'

export default ({ children, ...rest }) => {
  return (
    <button className={classes.Button} {...rest}>
      {children}
    </button>
  )
}
